export const normalizeGroupDeliveriesResponse = (
	response: IApiCommonModel<IGroupDelivery[]> | IGroupDelivery[],
): IGroupDelivery[] => {
	if (Array.isArray(response)) {
		return response
	}

	if (Array.isArray(response?.data)) {
		return response.data
	}

	return []
}

export const GroupDeliveryAddress = (json: IGroupDeliveryAddress): IGroupDeliveryAddressModel => {
	const { apartment_number, building_number, courier_instructions, delivery_phone_number, entry_code, ...rest } = json

	return {
		...rest,
		apartmentNumber: apartment_number,
		buildingNumber: building_number,
		courierInstructions: courier_instructions,
		deliveryPhoneNumber: delivery_phone_number,
		entryCode: entry_code,
	}
}

export const LogisticOrderUnit = (json: ILogisticOrderUnit): ILogisticOrderUnitModel => {
	const {
		unit_id,
		friendly_id,
		unit_id_friendly,
		unit_number,
		unit_type,
		best_before,
		total_weight,
		total_value,
		region_identifier,
		region_forwarder,
		region_branch,
		delivery_notes_consolidated,
		created_at,
		updated_at,
		...rest
	} = json

	return {
		...rest,
		unitId: unit_id,
		friendlyId: friendly_id,
		unitIdFriendly: unit_id_friendly,
		unitNumber: unit_number,
		unitType: unit_type,
		bestBefore: best_before,
		totalWeight: total_weight,
		totalValue: total_value,
		regionIdentifier: region_identifier,
		regionForwarder: region_forwarder,
		regionBranch: region_branch,
		deliveryNotesConsolidated: delivery_notes_consolidated,
		createdAt: created_at,
		updatedAt: updated_at,
	}
}

export const GroupDelivery = (json: IGroupDelivery): IGroupDeliveryModel => {
	const {
		friendly_id,
		external_module_id,
		external_module_type,
		external_module,
		custom_label_description,
		client_id,
		delivery_date_from,
		delivery_date_to,
		delivery_valid_to,
		created_at,
		updated_at,
		logistic_order_units,
		address,
		...rest
	} = json

	return {
		...rest,
		address: GroupDeliveryAddress(address),
		friendlyId: friendly_id,
		externalModuleId: external_module_id,
		externalModuleType: external_module_type,
		externalModule: external_module,
		customLabelDescription: custom_label_description,
		clientId: client_id,
		deliveryDateFrom: delivery_date_from,
		deliveryDateTo: delivery_date_to,
		deliveryValidTo: delivery_valid_to,
		createdAt: created_at,
		updatedAt: updated_at,
		logisticOrderUnits: logistic_order_units.map(LogisticOrderUnit),
	}
}

export const GroupDeliveries = (json: IGroupDelivery[]): IGroupDeliveryModel[] => json.map(item => GroupDelivery(item))

export const sumInsideCounts = (inside: InsideCounts): number =>
	Object.values(inside).reduce((sum, count) => sum + count, 0)
